import {useCallback} from 'react';
import {useThree} from '@react-three/fiber';
import {useARStore} from 'stores';

const useScreenshot = () => {
  const gl = useThree(s => s.gl);
  const camera = useThree(s => s.camera);
  const compositeMeshRef = useARStore(s => s.compositeMeshRef);
  const setScreenshotData = useARStore(s => s.setScreenshotData);

  const handleScreenshot = useCallback(() => {
    if (!compositeMeshRef.current) {
      return;
    }
    const xrRenderTarget = gl.getRenderTarget();
    gl.setRenderTarget(null);
    gl.render(compositeMeshRef.current, camera);

    const canvas = document.createElement('canvas');
    canvas.width = gl.domElement.width;
    canvas.height = gl.domElement.height;
    const ctx = canvas.getContext('2d');
    ctx?.drawImage(gl.domElement, 0, 0);

    gl.setRenderTarget(xrRenderTarget);

    const imageDataURL = canvas.toDataURL('image/jpeg');
    setScreenshotData(imageDataURL);
  }, []);

  return {handleScreenshot};
};

export default useScreenshot;
